import { CompanyId } from '@business/entities/companies';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '../storage';
import { ImpersonateResponse } from '@business/entities/account';

const APP_CONFIG_KEY = 'config:app';


export interface Data {
  companyId: CompanyId | null;
  appId: string | null;
  projectId: string | null;
  projectTitle: string | null;
  contactId: string | null;
  orgId: string | null;
  impersonate: ImpersonateResponse
}

const defaultConfig: Data = { companyId: null, appId: null, projectId: null, contactId: null, orgId: null, projectTitle: null, impersonate:null };

export const changed$ = new BehaviorSubject<Data>(defaultConfig);

export const get = () => {
  const config = Storage.get<Data>(APP_CONFIG_KEY);
  if (config) {
    changed$.next(config);
  }
  return config || defaultConfig;
};

export const set = (newConfig: Partial<Data>) => {
  const config = Storage.get<Data>(APP_CONFIG_KEY);
  const updated: Data = { ...(config ? config : defaultConfig), ...newConfig };
  changed$.next(updated);
  Storage.set(APP_CONFIG_KEY, updated);
};

export const clear = () => {
  changed$.next(defaultConfig);
  return Storage.remove(APP_CONFIG_KEY);
};

export const current = () => {
  return changed$.value;
};
